const semanticTokens = {
  colors: {
    divider: {
      'default': 'blue.100',
      _dark: 'whiteAlpha.200',
    },
    text: {
      'default': 'gray.900',
      _dark: 'whiteAlpha.900',
    },
    text_secondary: {
      'default': 'gray.600',
      _dark: 'gray.400',
    },
    link: {
      'default': 'blue.800',
      _dark: 'blue.300',
    },
    link_hovered: {
      'default': 'blue.900',
      _dark: 'blue.200',
    },
    icon_link_external: {
      'default': 'gray.500',
      _dark: 'gray.500',
    },
    icon_info: {
      'default': 'blue.700',
      _dark: 'blue.300',
    },
    error: {
      'default': 'red.500',
      _dark: 'red.500',
    },
    dialog_bg: {
      'default': 'white',
      _dark: 'gray.900',
    },
    nav_bg: {
      'default': 'white',
      _dark: 'gray.900',
    },
    nav_text: {
      'default': 'gray.700',
      _dark: 'gray.300',
    },
    nav_text_active: {
      'default': 'blue.700',
      _dark: 'blue.200',
    },
    nav_bg_active: {
      'default': 'blue.50',
      _dark: 'blue.900',
    },
    card_bg: {
      'default': 'white',
      _dark: 'gray.800',
    },
    hero_gradient_start: {
      'default': '#1E3A8A',
      _dark: '#1E3A8A',
    },
    hero_gradient_end: {
      'default': '#2563EB',
      _dark: '#2563EB',
    },
  },
  shadows: {
    action_bar: '0 4px 4px -4px rgb(0 0 0 / 10%), 0 2px 4px -4px rgb(0 0 0 / 6%)',
    card: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    card_hover: '0 4px 6px -1px rgba(37, 99, 235, 0.15), 0 2px 4px -1px rgba(37, 99, 235, 0.10)',
  },
};

export default semanticTokens;
